import type { IconDefinition } from '../../types'

export default {
  details: [448, 512, [], '', 'M395.4 159.9H256V75c0-35.5-43-53.5-68.3-28.3L15.4 218.8c-20.6 20.6-20.6 53.8 0 74.4l172.3 172.1c25.1 25.1 68.3 7.4 68.3-28.3v-85h139.4c29 0 52.6-23.6 52.6-52.6v-86.9c0-29-23.6-52.6-52.6-52.6zM416 299.4c0 11.4-9.2 20.6-20.6 20.6H224v117c0 7.1-8.6 10.7-13.7 5.7L38 270.6c-8-8-8-21.1 0-29.1L210.3 69.4c5-5 13.7-1.5 13.7 5.7v117h171.4c11.4 0 20.6 9.2 20.6 20.6z'],
  name: 'uiArrowAltLeft',
  oldName: 'falArrowAltLeft'
} as IconDefinition
